import { useMutation } from '@tanstack/react-query'
import { APIInstance } from '@/utils/functions/instance'
import { IApiBaseTypes } from '@/types/query-api'
import { IResponseType } from '@/types/response-type'

export function useSubmitContract({
  disableToast,
  ...rest
}: IApiBaseTypes<void>) {
  return useMutation({
    mutationFn: async () => {
      const response = await APIInstance<IResponseType<null>>({
        url: '/mrf/contract/',
        method: 'post'
      })
      return response.data
    },
    retry: 0,
    mutationKey: ['submitContract'],
    ...rest
  })
}
